import React, { lazy } from 'react'
import { PrivateRoute } from 'components'
import { Navigate } from 'react-router-dom'

const Checkout = lazy(() => import('../pages/B2C/Checkout'))
const Cart = lazy(() => import('../pages/B2C/Cart'))

const Routes = [

  {
    path: '/checkout/*',
    element: <Checkout />,
  },
  {
    path: '/cart/*',
    element: <Cart />,
  },
  {
    path: '*',
    element: <Navigate to={'/store'} replace />,
  },
]

export default Routes
